export default class ConvertUtil {

    public static weightConvert = (value: number, source: string, target: string): number => {
        if ((source == "pounds" && target == "kg") || (source == "lb" && target == "kg") || (source == "pounds" && target == "kilograms") || (source == "lb" && target == "kilograms")) {
            return ConvertUtil.poundsToKg(value);
        }
        if ((source == "kilograms" && target == "lb") || (source == "kilograms" && target == "pounds") || (source == "kg" && target == "lb") || (source == "kg" && target == "pounds")) {
            return ConvertUtil.kgToPounds(value);
        }
        return value;
    }

    public static poundsToKg = (value: number): number => {
        return value * 0.453592;
    }

    public static kgToPounds = (value: number): number => {
        return value * 2.20462;
    }
}
